<template>
  <v-card outlined class="signatures-block mt-3">
    <div class="pa-3">
      <div class="d-flex align-center mb-2">
        <v-icon small color="grey" class="mr-2">mdi-draw</v-icon>
        <span class="subtitle-2 font-weight-medium">Firmas</span>
        <v-chip x-small class="ml-2" color="grey lighten-2">
          <v-icon x-small left>mdi-lock</v-icon>
          Fijo
        </v-chip>
      </div>
      <div class="caption grey--text text--darken-1 mb-2">
        Se añaden automáticamente al final del documento. No es editable ni forma parte de la plantilla.
      </div>
      <ul class="body-2 grey--text text--darken-2 pl-4">
        <li>
          <strong>Entrega:</strong> Cedente (sello del dealer, configurado en Comodatos) y Cesionario (firma del conductor, capturada en el teléfono). Si hay segundo conductor, también se incluye su firma.
        </li>
        <li>
          <strong>Devolución:</strong> Cedente y Cesionario. Solo aparecen firmadas cuando el vehículo ya se ha recibido.
        </li>
      </ul>
      <v-alert v-if="hasStamp === false" type="warning" text dense class="mt-3 mb-0" icon="mdi-stamper">
        Falta el sello del dealer. Cárgalo en Configuración → Comodatos; mientras tanto el hueco del Cedente queda vacío.
      </v-alert>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    // true/false si se conoce el sello del dealer; null = no aplica (p. ej. plantillas de Grupo)
    hasStamp: { type: Boolean, default: null }
  }
}
</script>
